var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppLightroomClassic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.26 0H9.74C4.36075 0 0 4.36075 0 9.74V44.26C0 49.6393 4.36075 54 9.74 54H44.26C49.6393 54 54 49.6393 54 44.26V9.74C54 4.36075 49.6393 0 44.26 0Z",
    fill: "#001E36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62012 14.4331H10.1701V33.2631H19.8301V39.2231H3.62012V14.4331Z",
    fill: "#31A8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9201 19.5731C30.6601 19.5731 31.2901 19.6131 31.7701 19.6831V24.9031C31.4701 24.8631 31.1801 24.8631 30.8101 24.8631C29.1801 24.9031 28.0001 25.0531 27.2901 25.2331V39.2231H21.3001V20.9831C23.7801 19.9431 27.3301 19.5731 29.9201 19.5731Z",
    fill: "#31A8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2201 14.9131L50.1801 21.0931C48.8101 20.3131 47.7701 19.9431 45.6701 19.9431C42.1201 19.9431 39.6801 22.0931 39.6801 26.5331C39.6801 31.4531 42.0101 33.7831 45.6401 33.7831C47.0801 33.7831 48.8601 33.5231 50.3001 32.5631L50.3701 38.5931C49.4101 39.2231 47.7401 39.6331 44.7801 39.6331C36.3401 39.7031 32.6801 33.6731 32.6801 26.6431C32.6801 19.6131 37.1201 13.9531 44.9601 13.9131C47.4001 13.8731 49.1001 14.2431 50.2101 14.9131C50.2101 14.9131 50.2101 14.9131 50.2201 14.9131Z",
    fill: "#31A8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppLightroomClassic);
export default __webpack_public_path__ + "static/media/B_app_LightroomClassic.2c905aece1e325c4c6dfb69d9bdd1d4a.svg";
export { ForwardRef as ReactComponent };